import React from 'react';
import { FormControlLabel, RadioGroup, Radio } from '@mui/material';
import SkeletonWrapper from './skeleton/SkeletonWrapper';
import cx from 'classnames';

/**
 * @typedef {object} MuiRadioGroupProps
 * @property {number} [input]
 * @property {string} [name]
 * @property {boolean} [disabled]
 * @property {Array<*>} [options]
 * @property {(event: React.ChangeEvent<HTMLInputElement>, value: string) => void} [handleOnChange]
 * @property {boolean} [loading]
 * @property {boolean} [row]
 * @property {boolean} [hasError]
 */

/**
 * @param {MuiRadioGroupProps} props
 */
const MuiRadioGroup = props => {
  const {
    input,
    name,
    disabled,
    options,
    handleOnChange,
    loading = false,
    row = true,
    hasError = false
  } = props;

  return (
    <RadioGroup
      row={row}
      onChange={handleOnChange}
      name={name}
      className={cx({ hasError: hasError })}>
      <SkeletonWrapper show={loading} inheritParentSize={true}>
        {options.map(x => (
          <FormControlLabel
            key={x.key}
            checked={x.key === input}
            value={x.key}
            control={<Radio color='default' disabled={disabled} />}
            label={x.value}
          />
        ))}
      </SkeletonWrapper>
    </RadioGroup>
  );
};

export default MuiRadioGroup;
